<template>
  <div class="">
    <div class="panal mt-20">
      <div class="panal-header">Your Booking</div>
      <div class="panal-body">
  
 <div class="mt-4 text-center">
  <h4>Seats available<span class="text-success"> {{priceAndSeats.AvailableCapacity}}</span></h4>
  </div>




  <div class="row">
  <div class="col-sm-6">
    <div class="card">
      <div class="card-body">
        
 <img src="../../assets/booking.jpg" class="w-100 border ">
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">ONWARD FARE <span class="float-right">AMONT</span></h5>
        <p class="card-text">Bus Fare <span class="float-right">{{priceAndSeats.Price}}</span></p>
        <p class="card-text">Inclusive <span class="float-right">00.00</span></p>
        <hr/>
        <p class="card-text">Total Fare <span class="float-right">{{priceAndSeats.Price}}</span></p>
      </div>
    </div>
  </div>
  </div>
   <div class="row justify-content-center">
   <div class="col-sm-8 mt-3 ">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Passenger Details</h5>
        <p class="card-text">Email: <span class="text-success">{{currenUser.UserEmail}}</span></p>
        <p class="card-text">ID: <span class="text-success">{{currenUser.Username}}</span></p>
        <p class="card-text">Name: <span class="text-success">{{currenUser.FirstNameEN + ' ' + currenUser.SecondNameEN + ' ' + currenUser.ThirdNameEN + ' ' + currenUser.LastNameEN}}</span></p>
        <!-- <p class="card-text">Gender: <span class="text-success">{{cu}}</span></p> -->
        <!-- <p class="card-text">Seat No.: <span class="text-success">55</span></p>
        <p class="card-text">Note: <span class="text-success">Text text</span></p> -->
        <hr/>
        <p class="card-text text-worning">"Payment Within <span class="text-danger text-bold">{{priceAndSeats.GracePeriod}} </span>days then the reservation will be canceled"</p>
       <div class="text-center">
        <a  class="btn btn-outline-secondary"   id="v-pills-History-tab" data-toggle="pill" href="#v-pills-History" 
          role="tab" aria-controls="v-pills-History">Cancel </a>  
        <a href="#"  class="btn btn-primary" @click="confirmBooking">Confirm Booking </a>

        <b-modal id="confirm" title="Booking Completed" :header-bg-variant="headerBgVariant" ok-only>
    <p class="my-4 text-center"> <b-icon icon="bell-fill" class="  p-2 text-success"></b-icon></p>
    <p class="text-center">

      

      Booking Completed <br/>

Thank You!
    </p>
    
    
  </b-modal>
        </div>
           
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
  </div>
</template>

<script>
import TransportationService from '../../services/Transportation/Transportation.service';




export default {
  name: "Packages",
  props:['priceAndSeats','currenUser','serial'],
  data() {
    return {
      headerBgVariant: 'primary',

    };
  },

  mounted(){
 


  },
  methods:{
    confirmBooking(){
      let  ConfirmObj= {
          USERID :this.currenUser.UserIDSerial ,
          ApplicantId : this.currenUser.UserIDSerial,
          Price :this.priceAndSeats.Price ,
          Graceperiod :this.priceAndSeats.GracePeriod , 
          PersonType : 1,
          PersonCode : this.currenUser.Username ,
          PersonName : this.currenUser.FirstNameEN + ' ' + this.currenUser.SecondNameEN + ' ' + this.currenUser.ThirdNameEN + ' ' + this.currenUser.LastNameEN,
          RouteReservationID :this.serial
        }
        console.log(ConfirmObj)
        TransportationService.PostApplicantReservation(ConfirmObj).then(response=>{
          console.log(response.data)
          this.$bvModal.show("confirm")
        })
    }
  }
}
</script>

<style scoped>
.b-overlay div{
  inset: 0px;
    opacity: 0.35 !important;
    backdrop-filter: blur(2px);

}
.btn-light {
    color: #fff;
    background-color: #295EB2;
    border-color: #1a54b0;
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #d4d4d4;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>